import React from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import NumberFormat from "react-number-format";

export default function RecurringMonthlyPayments(props) {
    const { recurringPayments } = props;
    let totalAmount = 0;
    recurringPayments.forEach((payment) => {
        const amount = payment.amount[0].amount + payment.amount[1].amount + payment.amount[2].amount;
        totalAmount += amount; // Add to the totalAmount
    });

    return (
            <>
                <Grid container>
                    <Grid item xs={12}>
                        {recurringPayments && recurringPayments.map((payment) => {
                            const amount = payment.amount[0].amount + payment.amount[1].amount + payment.amount[2].amount;
                            return (
                                    <Typography variant="caption" className="mb10 floatLeft w100">
                                        {moment(payment.date).format("MM/DD/YYYY") + " "}
                                        <span className="floatRight mr10">
                                    <NumberFormat
                                            value={amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            prefix={"$"}
                                    />
                                </span>
                                    </Typography>
                            );
                        })}
                    </Grid>
                    <Grid item xs={12}>
                        <span className="hLine" />
                    </Grid>
                    <Typography component="strong" variant="caption" className="floatLeft w100 mb0">
                        Total Due
                        <span className="floatRight">
                        <NumberFormat
                                value={totalAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                        />
                    </span>
                    </Typography>
                </Grid>
            </>
    );
}
